const outside = require('./outside')
// Determine if version is less than all the versions possible in the range
const ltr = (version, range, options) => outside(version, range, '<', options)
module.exports = ltr



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/ranges/ltr.js
// module id = 1424
// module chunks = 0